import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filter",
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(dataset: Record<string, unknown>[], field: string, value: unknown): Record<string, unknown>[] {
    if (field.length >= 2) {
      if (field.startsWith(">=")) {
        return dataset.filter((i) => (i[field.slice(2)] as number) >= +value);
      }
      if (field.startsWith("<=")) {
        return dataset.filter((i) => (i[field.slice(2)] as number) <= +value);
      }
      if (field.startsWith(">")) {
        return dataset.filter((i) => (i[field.slice(1)] as number) > +value);
      }
      if (field.startsWith("<")) {
        return dataset.filter((i) => (i[field.slice(1)] as number) < +value);
      }
      if (field.startsWith("=")) {
        return dataset.filter((i) => i[field.slice(1)] == value);
      }
      if (field.startsWith("!=")) {
        return dataset.filter((i) => i[field.slice(2)] !== value);
      }
    }
    return dataset.filter((i) => i[field] === value);
  }
}
